import { Helmet } from 'react-helmet-async';

const DEFAULTS = {
  title: 'Jwalek — Design it your way, we print it perfectly',
  description: 'Custom-printed iPhone cases, stickers, and labels. Design your own with our AI-powered editor or pick from thousands of templates. Fast delivery, premium quality.',
  image: 'https://jwalek.com/og-image.png',
  url: 'https://jwalek.com/',
  siteName: 'Jwalek',
  keywords: 'custom phone case, custom stickers, custom labels, print on demand, iPhone case, vinyl stickers, product labels, AI design generator, Jwalek',
};

export const SEO = ({
  title,
  description,
  image,
  url,
  path,
  keywords,
  type = 'website',
  noindex = false,
  jsonLd,
}) => {
  const fullTitle = title
    ? (title.includes('Jwalek') ? title : `${title} — Jwalek`)
    : DEFAULTS.title;
  const desc = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const canonical = url || (path ? `https://jwalek.com${path}` : DEFAULTS.url);
  const kw = keywords || DEFAULTS.keywords;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
